import React from 'react';
import Header from '../Components/Header';
import SideMenu from '../Components/SideMenu';
import RoadDetailsForm from '../Components/RoadDetailsForm';
import cp1 from '../Images/cp1.png';
import cp2 from '../Images/cp2.png';
import cp3 from '../Images/cp3.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';

const CompensationNewProposalForm = () => {
  return (
    <div className="flex flex-col h-screen">
    {/* Header */}
    <div className="mx-4">
      <Header />
    </div>

    {/* Main Content */}
    <div className="flex flex-1 overflow-hidden">
      {/* Sidebar */}
      <SideMenu className="hidden sm:block w-1/4 bg-gray-200" />

      {/* Main Section */}
      <div className="flex-1 p-4 overflow-y-auto">
        {/* Header Section */}
        <div className="border-b pb-2 flex items-center justify-between text-lg font-bold">
          <h1 className="text-start">Compensation Proposal</h1>
          <button className="text-sm border text-black px-4 py-2 rounded-3xl border-[#241C68] hover:bg-blue-600 hover:text-white hover:border-white">
            New Proposal <FontAwesomeIcon icon={faFileSignature} />
          </button>
        </div>

        <div className="p-6">
          
      <RoadDetailsForm />
    </div>
        </div>
      </div>
    </div>
  );
};

export default CompensationNewProposalForm;